let htmlULid = '#layers_list';
let htmlClassCategory = 'clickCategory';
let htmlClassItem = 'clickItem';
let idHTML = '_ID_';
let numberHTML = '_NUMBER_';
let nameHTML = '_NAME_';
let accTitleHTML = '\
    <div class="accordion-item">\
      <div class="accordion-header"></div>\
        <input type="checkbox" class="form-check-input '+ htmlClassCategory + ' ' + htmlClassCategory + '' + numberHTML + '" data-collapseid="' + numberHTML + '" id="' + idHTML + '" checked>\
        <a class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse'+ numberHTML + '" aria-expanded="false" aria-controls="collapse' + numberHTML + '" data-translate="' + nameHTML + '"></a>\
      </div>\
    </div>';
let accItemStartHTML = '\
    <div id="collapse'+ numberHTML + '" style="margin-left:0px;background-color: #ffffff85;padding: 5px;padding-left: 50px" class="accordion-collapse collapse ml-4">';
let accItemCenterHTML = '\
      <div class="form-group form-check pl-4">\
        <input type="checkbox" class="form-check-input ' + htmlClassItem + ' ' + htmlClassItem + '' + numberHTML + '" data-collapseid="' + numberHTML + '" id="' + idHTML + '" checked>\
        <label class="form-check-label" for="'+ idHTML + '" data-translate="' + nameHTML + '"></label>\
      </div>';
let accItemEndHTML = '\
    </div>';
let items = [
  ["stageYouth", "stageSchools", "stagePilgrimage", "stageCongress", "stageDietPoland", "stageDietPrussia", "stageOther"],
  ["stageDiplomat", "stage1mission", "stage2mission", "stage3mission", "stageDietPoland", "stageOther"],
  ["stageBishop", "stage4mission", "stageDietPoland", "stageDietPrussia", "stageOther"],
];
let itemsIdNames = [
  ["stage1", "stay12_stage1", "travel4", "travel5", "stay11_stage1", "stay10_stage1", "stay1_other"],
  ["stage2", "travel6", "travel7", "travel8", "stay11_stage2", "stay2_other"],
  ["stage3", "travel9", "stay11_stage3", "stay10_stage3", "stay3_other"],
];

function createUL() {
  let HTML = '';
  $.each(items, function (i, v) {
    $.each(v, function (index, value) {
      if (index == 0) {
        HTML += accTitleHTML;

        HTML = HTML.replaceAll(numberHTML, i).replaceAll(idHTML, itemsIdNames[i][0]).replaceAll(nameHTML, value);
      } else {
        if (index == 1) {
          HTML += accItemStartHTML;
        }
        HTML += accItemCenterHTML

        HTML = HTML.replaceAll(numberHTML, i).replaceAll(idHTML, itemsIdNames[i][index]).replaceAll(nameHTML, value);
      }
    });
    HTML += accItemEndHTML;
  });
  $(htmlULid).append(HTML);
}

function registerCategoryClick() {
  $(htmlULid).on('change', 'input.' + htmlClassCategory, function () {
    $(this).prop('indeterminate', false);

    $(this).parent().parent().find('input.' + htmlClassItem + $(this).data('collapseid')).prop('checked', /*!*/$(this).is(':checked'));//.click();
  });
}

function registerItemClick() {
  $(htmlULid).on('change', 'input.' + htmlClassItem, function () {
    let id = $(this).data('collapseid');
    let i = 0;
    let j = 0;
    $(this).parent().parent().parent().find('input.' + htmlClassItem + id).each(function () {
      i += ($(this).is(':checked') ? 1 : 0);
      j += 1;
    });

    let categoryCheckbox = $(this).parent().parent().parent().find('input.' + htmlClassCategory + id);
    if (i == j) {
      categoryCheckbox.prop('indeterminate', false);
      categoryCheckbox.prop("checked", true);
    } else if (i == 0) {
      categoryCheckbox.prop('indeterminate', false);
      categoryCheckbox.prop("checked", false);
    } else {
      categoryCheckbox.prop('indeterminate', true);
      categoryCheckbox.prop("checked", false);
    }
  });
}

createUL();
registerCategoryClick();
registerItemClick();

